export default {
  import: {},
  hasHydration: false,
  hasTeamData: false,
  hasPositionData: false,
  editData: [],
  athleteArr: [],
  invalidData: [],
  parsedCsv: {},
  clubTeams: [],
  clubPositions: [],
  columns: {},
  unique: {
    columns: [],
  },
  activeStep: 0,
  setupProgress: false,
  pages: [
    { name: "clubimport.columns" },
    { name: "clubimport.match" },
    { name: "clubimport.clean" },
    { name: "clubimport.review" },
  ],
  suggestedColumns: [],
  processingAll: {
    editData: [],
  },
  matchedColumns: {},
  removedFromRoster: [],
  removedAthletes: [],
  removedEditData: [],
  existingAthletes: [], 
  previousImports: [], 
  isLoadingPreviousImports: false,
  submitRoster: false,
  hasFetchedAthletes: false,
  hasChosenImportType: false,
  disableContinueButton: false,
  isResolvingAthletesWithMissingEmails: false,
  totalAthletesWithMissingEmailsBeingResolved: 0,
  hasMatchedTeams: false,
  hasMatchedPositions: false,
  importUploadErrors: [],
  isUploadingImport: false,
};
